import { useDashboardStore } from '../store/dashboardStore'
import { translations } from '../constants/translations'

export function useT() {
  const language = useDashboardStore(s => s.language)
  return translations[language] ?? translations.en
}
